"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect } from "react";
import { useLocalStorage } from "usehooks-ts";
import { ACCENT_STORAGE_KEY, applyAccent, DEFAULT_ACCENT, parseAccentId } from "@/lib/accent";
export function AccentProvider(t0) {
  const $ = _c(3);
  const {
    children
  } = t0;
  const [stored] = useLocalStorage(ACCENT_STORAGE_KEY, DEFAULT_ACCENT);
  let t1;
  let t2;
  if ($[0] !== stored) {
    t1 = () => {
      applyAccent(parseAccentId(stored));
    };
    t2 = [stored];
    $[0] = stored;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  return children;
}